export const RECOMMENDED_SERVICE_IMAGES = {
  recommendedSofaCleaning:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-sofa-cleaning.png",
  recommendedPlumbing:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-plumbing.png",
  recommendedPetSitting:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-pet-sitting.png",
  recommendedPetGrooming:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-pet-grooming.png",
  recommendedMedicalEscort:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-medical-escort.png",
  recommendedMattressCleaning:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-mattress-cleaning.png",
  recommendedManicurePedisure:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-manicure-pedisure.png",
  recommendedMaidAgency:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-maid-agency.png",
  recommendedHomeMassage:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-home-massage.png",
  recommendedHomeFacial:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-home-facial.png",
  recommendedHandyman:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-handyman.png",
  recommendedFloorPolishing:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-floor-polishing.png",
  recommendedEyelash:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-eyelash.png",
  recommendedEldercare:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-eldercare.png",
  recommendedElectrician:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-electrician.png",
  recommendedDeepCleaning:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-deep-cleaning.png",
  recommendedCurtainCleaning:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-curtain-cleaning.png",
  recommendedCarpetCleaning:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-carpet-cleaning.png",
  recommendedBabysitter:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-babysitter.png",
  recommendedAirconServices:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-aircon-services.png",
  recommendedAirconRepairDiagnostic:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-aircon-repair-diagnostic.png",
  recommendedAirconGeneralServicing:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-aircon-general-servicing.png",
  recommendedAirconGasTopup:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-aircon-gas-topup.png",
  recommendedAirconCompressorWash:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-aircon-compressor-wash.png",
  recommendedAirconChemicalWash:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-aircon-chemical-wash.png",
  recommendedAirconChemicalOverhaul:
    "https://luce-production.sgp1.cdn.digitaloceanspaces.com/public/recommended-services/recommended-aircon-chemical-overhaul.png",
};
